import getIn from 'transmute/getIn';
export const getForecastedAmount = rowData => {
  const {
    columnTotal,
    forecastLastModified,
    forecastValue,
    id,
    isTotalRow,
    isUser,
    teamSubmissionAmount,
    userSubmissionTotal
  } = rowData;
  const isTeamRow = !isUser && id;
  // [Team View] If we are a team row with forecastLastModified date, we will display the team forecast submission value
  if (isTeamRow && (forecastLastModified || getIn(['value'], teamSubmissionAmount)) && teamSubmissionAmount) {
    return teamSubmissionAmount;
  }
  // [Team View] If we are a total team row, and there is no forecastLastModified date, we will display the column total
  else if (isTeamRow && isTotalRow && columnTotal) {
    return columnTotal;
  }
  // [Team View] If we are a regular team row, and there is no forecastLastModified date, we will display the rollup amount for the users under that team
  else if (isTeamRow && userSubmissionTotal) {
    return userSubmissionTotal;
  }
  // [Team and User View] If we are user row we will display the forecast submission value.
  // [User View] If we are a total row in user view, we will also display the forecast submission value (as it is a total here, not a team submission)
  else {
    return forecastValue;
  }
};